module.exports = __webpack_public_path__ + "static/media/icon-logout.b30d1459.svg";